var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilterIcon = function SvgFilterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18.7500001px",
    height: "10.0000001px",
    viewBox: "0 0 18.7500001 10.0000001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.12.10-All-screenings---completed-when-report-not-ready-action",
    transform: "translate(-963.625000, -152.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-Copy",
    transform: "translate(256.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-filter",
    transform: "translate(20.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    transform: "translate(673.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(12.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.75,6.99999997 C21.095178,6.99999997 21.375,7.27982201 21.375,7.62499998 C21.375,7.97017795 21.095178,8.24999998 20.75,8.24999998 L3.24999996,8.24999998 C2.90482199,8.24999998 2.62499995,7.97017795 2.62499995,7.62499998 C2.62499995,7.27982201 2.90482199,6.99999997 3.24999996,6.99999997 L20.75,6.99999997 Z M17.625,11.375 C17.970178,11.375 18.25,11.654822 18.25,12 C18.25,12.345178 17.970178,12.625 17.625,12.625 L6.37499997,12.625 C6.029822,12.625 5.74999997,12.345178 5.74999997,12 C5.74999997,11.654822 6.029822,11.375 6.37499997,11.375 L17.625,11.375 Z M13.875,15.75 C14.220178,15.75 14.5,16.0298221 14.5,16.375 C14.5,16.720178 14.220178,17 13.875,17 L10.125,17 C9.77982202,17 9.49999999,16.720178 9.49999999,16.375 C9.49999999,16.0298221 9.77982202,15.75 10.125,15.75 L13.875,15.75 Z",
    id: "Combined-Shape"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-icon.79d44736.svg";
export { ForwardRef as ReactComponent };